import { postJson } from "../api/client";

export type OtpResponse = {
  ok: boolean;
  requestId?: string;
  message?: string;
};

export const sendOtp = (email: string) =>
  postJson<{ email: string }, OtpResponse>("/api/auth/send-otp", { email });

export const verifyOtp = (email: string, otp: string) =>
  postJson<{ email: string; otp: string }, OtpResponse>("/api/auth/verify-otp", {
    email,
    otp
  });

export const requestPasswordReset = (email: string) =>
  postJson<{ email: string }, OtpResponse>("/api/auth/forgot-password", { email });
